import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface PhoneFrameProps {
    src: string
    alt: string
    className?: string
    eager?: boolean
    priority?: boolean
}

export const PhoneFrame: FC<PhoneFrameProps> = ({
    src,
    alt,
    className,
    eager = false,
    priority = false
}): ReactNode => {
    return (
        <div className={cn('rounded-[2.25rem] bg-ink p-2 shadow-phone ring-1 ring-white/10', className)}>
            <div className='relative aspect-[9/16.5] overflow-hidden rounded-[1.75rem] bg-[#fbf7ef]'>
                <img
                    src={src}
                    alt={alt}
                    loading={eager || priority ? 'eager' : 'lazy'}
                    fetchPriority={priority ? 'high' : 'auto'}
                    decoding='async'
                    className='absolute inset-x-0 top-0 h-auto w-full'
                />
            </div>
        </div>
    )
}
